import {observer} from "mobx-react";
import React, {useState} from "react";
import ScoreTag from "../../components/ScoreTag";
import {useSwipeable} from "react-swipeable";
import FakeTable from "../../components/FakeTable";
import {Alert, Card} from "antd";
import BottomSideDrawer from "../../components/BottomSideDrawer";
import MobileTitle from "../../components/MobileTitle";
import {pp} from "../../utils";
import PlayerNameLink from "./PlayerNameLink";

const MatchMV = observer(({m, teamById}) => {
  let full = (m.t1w >= 3 || m.t2w >= 3);
  let one = m.t1w + m.t2w >0 || null;

  let t1 = teamById[m.t1_id];
  let t2 = teamById[m.t2_id];

  const [show, setShow] = useState(false)

  let open = () => {
    setShow(true);
  }

  let spacer = (a, b, props) => <div className="h-space" {...props}>
    <div>{a}</div>
    <div>{b}</div>
  </div>

  let tieGr = (g, title) => <tr>
    <td style={{width: "45%"}}>
      <div style={{marginBottom: "3px"}}><ScoreTag w="50px" type={g.t1p > g.t2p ? 'win' : 'lose'} v={g.t1p} /></div>
    </td>
    <td style={{width: "50px", textAlign: "center", fontWeight: 'bold'}}>{title}</td>
    <td style={{width: "45%", textAlign: "right"}}>
      <div style={{marginBottom: "2px"}}><ScoreTag style={{marginLeft: "auto"}} w="50px" type={g.t1p < g.t2p ? 'win' : 'lose'} v={g.t2p} /></div>
    </td>
  </tr>

  let gr = (g, title) => <tr>
    <td style={{width: "45%"}}>
      <div style={{marginBottom: "3px"}}><ScoreTag w="50px" type={g.t1p > g.t2p ? 'win' : 'lose'} v={g.t1p} /></div>
      <div><PlayerNameLink pl={g.players[0]} withStats/></div>
      <div><PlayerNameLink pl={g.players[1]} withStats/></div>
    </td>
    <td style={{width: "50px", textAlign: "center", fontWeight: 'bold'}}>{title}</td>
    <td style={{width: "45%", textAlign: "right"}}>
      <div style={{marginBottom: "2px"}}><ScoreTag style={{marginLeft: "auto"}} w="50px" type={g.t1p < g.t2p ? 'win' : 'lose'} v={g.t2p} /></div>
      <div><PlayerNameLink pl={g.players[2]} withStats/></div>
      <div><PlayerNameLink pl={g.players[3]} withStats/></div>
    </td>
  </tr>;

  let close = () => setShow(false);

  const handlers = useSwipeable({
    onSwipedDown: close
  });

  let tbGame = m.games[4];
  let scores = _.isNumber(m.games[0].t1p) && <FakeTable className="match-mv-table">
    {gr(m.games[0], "G1")}
    {gr(m.games[1], "G2")}
    {gr(m.games[2], "G3")}
    {_.isNumber(m.games[3].t1p) && gr(m.games[3], "G4")}
    {tbGame.t1p ? tieGr(tbGame, "TB") : null}
  </FakeTable>

  let names = <FakeTable className="match-mv-table">
    {[0,1,2,3].map(i => <tr key={i}>
      <td>{t1.players[i].name}</td>
      <td/>
      <td style={{textAlign: 'right'}}>{t2.players[i].name}</td>
    </tr>)}
    <tr>
      <td colSpan={2} style={{textAlign: 'center'}}>
        <Alert type="info" message="waiting for results" />
      </td>
    </tr>
  </FakeTable>

  return <div className="cursor-pointer">
    {/*<Popup*/}
    {/*  visible={show}*/}
    {/*  onMaskClick={close}>*/}
    {/*  <div {...handlers}>*/}
    {/*    {spacer(t1.name, t2.name, { style: { margin: "8px", fontWeight: "bold"}})}*/}
    {/*    <Divider style={{margin: "0 8px"}}/>*/}
    {/*    { m.games[0].t1p ? scores : names }*/}
    {/*  </div>*/}
    {/*</Popup>*/}
    <BottomSideDrawer show={show} onClose={close}>
      {/*<div {...handlers}>*/}
      <div>
        {spacer(t1.name, t2.name, { style: { margin: "8px", fontWeight: "bold"}})}
        <hr/>
        { m.games[0].t1p ? scores : names }
      </div>
    </BottomSideDrawer>
    <Card size="small" extra={m.place && <div>{m.place === 1 ? "Gold/Silver" : "Bronze"}</div>} onClick={open} >
      <div className="space-y-2">
        <div className="h-space">
          <div>{t1.name}</div>
          {one && (full ? <ScoreTag type={m.t1w > m.t2w ? 'win' : 'lose'} v={m.t1w} /> : <ScoreTag type="invalid" v={m.t1w} />)}
        </div>
        <hr/>
        <div className="h-space">
          <div>{t2.name}</div>
          {one && (full ? <ScoreTag type={m.t2w > m.t1w ? 'win' : 'lose'} v={m.t2w} /> : <ScoreTag type="invalid" v={m.t2w} />)}
        </div>
      </div>
    </Card>
  </div>
});

let RoundsManagerMV = observer(({rounds, teamById}) => {
  return <div className="rounds-mv" style={{backgroundColor: "#f1f5f9"}}>
    {rounds.map((r, i) => <div key={i}>
      <MobileTitle title={r.name} />
      <div className="space-y-2">
        {r.matches.map((m, j) => <MatchMV teamById={teamById} key={m.id} m={m} />)}
      </div>
      {r.bye_ids.length > 0 && r.bye_ids.map(id => <Card key={id} size="small">
        <div className="h-space">
          <div>{teamById[id].name}</div>
          <div>BYE</div>
        </div>
      </Card>)
      }
    </div>)}
  </div>
});

export default RoundsManagerMV